
import '../sass/showcase.scss';
/* Project specific Javascript goes here. */


import '../js/components/scroll-to-top';

import '../js/components/multi-carousel';

import '../js/components/sideways-accordion';



function openDocument(title, href) {
    // TODO: Send to Analytics when set up
    // ga('send', 'event','click','Open ' + title);
    window.open(href, '_blank');
}

window.openDocument = openDocument;
